export default "<div>\n\t<router-outlet></router-outlet>\n</div>\n"